import {useQuery} from 'react-query';

import {ApiFlowContributingAreas, Project, fetchFlowContributingAreas} from 'src/lib/api/project';

export type MaybeApiFlowContributingAreas = ApiFlowContributingAreas | null | undefined;

export function useFlowContributingAreas(projectId: Project['id'] | undefined): {
  flowContributingAreas: MaybeApiFlowContributingAreas;
} {
  const {data: flowContributingAreas} = useQuery(['flowContributingAreas', projectId], () =>
    projectId ? fetchFlowContributingAreas(projectId) : Promise.resolve(null)
  );
  return {flowContributingAreas};
}
